import type { State } from '../../types';
import { currentEmployeeUuid } from './current-employee-uuid';
import { contractsNotDeleted } from '../documents/contracts-not-deleted';
import type { ListSectionItemInput } from '../../../library/lists/listSectionItemInput';
import { getListSectionMainIcon } from 'src/store/selectors/get-list-section-main-icon';
import { sortedByLabel } from 'src/store/utilities';

export function employeeContractsAsListItems(state: State, href: string, uuid: string): ListSectionItemInput[] {
  const current = currentEmployeeUuid(state);
  const items = contractsNotDeleted(state)
    .filter((c) => c.employees?.includes(uuid))
    .map((c) => {
      let moreref = '/contracts/' + c.uuid;
      if (!c.isConfirmedEntity || !c.name || c.unchangedTemplate) {
        moreref += '?edit';
      }
      return {
        href: href + moreref,
        label: c.name ?? '',
        mainIcon: getListSectionMainIcon('contracts', c.unchangedTemplate, c.classification),
        accessible: c.classification === 'NONE' || (current !== undefined && (c.accessControl ?? []).includes(current)),
        hasDraft: c.hasDraft,
      };
    });
  const notSuggestions = sortedByLabel(
    items.filter((item) => {
      return item.mainIcon !== 'suggestion';
    }),
  );
  const suggestions = sortedByLabel(
    items.filter((item) => {
      return item.mainIcon === 'suggestion';
    }),
  );
  return notSuggestions.concat(suggestions);
}
